import { CourseCardIcon } from "./CourseCardIcon";

import ClockSVG from './images/clock.svg';
import LocationSVG from './images/location.svg';
import TimeSVG from './images/time.svg';
import RightArrow from './images/right-arrow.png';

import { COURSE_DETAIL_URL } from "./Constant";

export const ShowingResults = (props) => {
  const { searchValue, key } = props;

  let formattedDeliveryType = searchValue.DeliveryType;
  if (formattedDeliveryType === "Fulltime" || formattedDeliveryType === "Parttime") {
    formattedDeliveryType = formattedDeliveryType.replace(/.{4}$/, '-$&');
  }

  return (
    <div className="showing-results single-course-item" key={key}>
      <div className="card-body box-shadow">
        <div className="single-course-title">
          <h3>
            <span className="text-primary">{searchValue.CourseId}</span>
            {searchValue.CourseTitle}
          </h3>
          <a href={COURSE_DETAIL_URL + searchValue.CourseId} title='Go to course' style={{ marginLeft: 'auto' }} target='_blank'>
            <img src={RightArrow} alt="Go to course" width={'50px'} height={'50px'} />
          </a>
          {/* <hr /> */}
        </div>
        <div className='course-info-list'>
          <ul>
            <li>
              <img src={ClockSVG} alt="Clock" className="course-list-icons" />
              <span>{formattedDeliveryType}</span>
            </li>
            <li>
              <img src={LocationSVG} alt="Location" className="course-list-icons" />
              <span>{searchValue.CourseLocation}</span>
            </li>
            <li>
              <img src={TimeSVG} alt="Time" className="course-list-icons" />
              <span>{searchValue.DurationWeeks} weeks</span>
            </li>
            <li>
              <CourseCardIcon title={searchValue.ISCEDDescription} />
              <span>{searchValue.ISCEDDescription}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};